import graphAxios from "../utils/graph-axios";
import { getFbAccessToken } from "../utils/helpers";

const getBusinesses = (fbUserID) => {
  const fbAccessToken = getFbAccessToken();
  console.log("🚀 ~ getBusinesses ~ fbAccessToken:", fbAccessToken)

  return graphAxios.get(
    `/${fbUserID}/businesses?fields=name,owned_pages.limit(2000),business_users,verification_status,created_time,owned_ad_accounts.limit(200){timezone_name,currency,name,timezone_offset_hours_utc}&limit=200`,
    {
      params: {
        access_token: fbAccessToken,
      },
    },
  );
};

const getBMSelected = (bmID) => {
  const fbAccessToken = getFbAccessToken();

  return graphAxios.get(
    `/${bmID}?fields=name,picture,owned_pages.limit(2000){name},business_users.limit(200),verification_status,created_time,owned_ad_accounts.limit(200){timezone_name,currency,name,timezone_offset_hours_utc}`,
    {
      params: {
        access_token: fbAccessToken,
      },
    },
  );
};

const changeRoles = ({ bmID, role }) => {
  return graphAxios.post(`/${bmID}`, `role=${role}`);
};

// const getBusinesses = async () => {
//   await new Promise((resolve) => setTimeout(resolve, 1000));
//   return graphAxios.get("/bm").then((res) => res.data);
// };

// const getBMSelected = (bmID) => {
//   return graphAxios.get(`/bm/${bmID}`).then((res) => res.data);
// };

// const changeRoles = ({ bmID, role }) => {
//   return graphAxios.post(`/bm/${bmID}`, `role=${role}`).then((res) => res.data);
// };

const BusinessAPI = {
  getBusinesses,
  getBMSelected,
  changeRoles,
};
export default BusinessAPI;
